module.exports = __webpack_public_path__ + "img/faq-accordion-down.367c9ccd.svg";